import { Box } from '@mui/material'
import AudioVisualizerCanvas from "./AudioVisualizerCanvas"

const draw3BarWave = ( ctx, levels, width, height ) => {
    const barWidth = width / 6
    const gap = barWidth
    const halfHeight = height / 2
    const barHeightMax = height * 0.8

    ctx.fillStyle = "white"
    levels.forEach( ( level, i ) => {

        const normalized = Math.min( 1, Math.max( 0, level ) )
        const barHeight = Math.max( 1, normalized * barHeightMax )
        const x = i * ( barWidth + gap )

        // Upper bar (from center up)
        const yTop = halfHeight - barHeight
        ctx.fillRect( x, yTop, barWidth, barHeight )

        // Lower bar (from center down)
        const yBottom = halfHeight
        ctx.fillRect( x, yBottom, barWidth, barHeight )
    } )
}

const AudioVisualizer3BarWaves = ( { audioTrack, size = 30, frameColor } ) => {
    return (
        <Box bgcolor={frameColor} display="flex" alignItems="center" justifyContent="center" paddingLeft="5px" width={`${size + 5}px`} borderRadius="50%" height={`${( size ) + 5}px`}>
            <AudioVisualizerCanvas
                audioTrack={audioTrack}
                type="3barwave"
                draw={draw3BarWave}
                frameColor={frameColor}
                width={size}
                height={size / 2}
            />
        </Box>
    )
}

export default AudioVisualizer3BarWaves
